import { Component, effect, inject, signal } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
import { LayerUploaded } from '@core/models/layers.model'
import { UploadedLayersService } from '@core/services/layers-uploaded.service'
import { LayersService } from '@core/services/layers.service'
import { LayerSharedCardComponent } from './card-layer-shared/card-layer-shared.component'

@Component({
  selector: 'app-shared-layers',
  templateUrl: './shared-layers.component.html',
  imports: [
    // Material
    MatTooltipModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    LayerSharedCardComponent,
  ],
})
export class SharedLayersComponent {
  private readonly _uploadedLayersService = inject(UploadedLayersService)
  layersService = inject(LayersService)
  readonly sharedExpanded$ = signal(false)

  sharedLayersState$ = this._uploadedLayersService.sharedLayersState$
  sharedLayers$ = this._uploadedLayersService.sharedLayers$
  filteredSharedLayers$ = this._uploadedLayersService.filteredSharedLayers$
  sortSelected$ = this._uploadedLayersService.sortSelectedSharedLayer$
  search$ = this.layersService.search$

  constructor() {
    // Open panel if layer selected by snapshot
    effect(() => {
      if (this.sharedLayers$().some((layer: LayerUploaded) => layer.isSelected)) {
        this.sharedExpanded$.set(true)
      }
    })

    // Expand when search returns shared results
    effect(() => {
      if (this.search$() && this.filteredSharedLayers$().length > 0) {
        this.sharedExpanded$.set(true)
      }
    })

    // Collapse if search cleared and shared layers haven't loaded yet
    effect(() => {
      if (this.search$() === '' && this.sharedLayersState$().status !== 'success') {
        this.sharedExpanded$.set(false)
      }
    })
  }

  filterSharedLayer(action: string): void {
    this._uploadedLayersService.sortUploadedLayers('shared', action)
  }

  async refreshSharedLayers() {
    this._uploadedLayersService.uncheckAllSharedLayers()
    await this._uploadedLayersService.listShare()
    this._uploadedLayersService.sortUploadedLayers('shared', this.sortSelected$())
  }

  onPanelOpened() {
    this.sharedExpanded$.set(true)
  }

  onPanelClosed() {
    this.sharedExpanded$.set(false)
  }
}
